const SEO = [
	{
		page: "home",
		description:
			"I work as a Cloud Engineer and I help companies deliver secure and scalable software in a resilient and fast manner by provisioning cloud infrastructure, developing automation and deployment pipelines, and by configuring monitoring tools that let us know when something is not right. I have extensive experience in the AWS cloud and in DevOps best practices, focusing primarily on communication, collaboration, automation and observability pillars",
		keywords: ["freelancer devops engineer", "freelancer cloud engineer", "freelancer operations engineer", "freelancer aws engineer"],
	},

	{
		page: "about",
		description:
			"I work as a Cloud Engineer and I help companies deliver secure and scalable software in a resilient and fast manner by provisioning cloud infrastructure, developing automation and deployment pipelines, and by configuring monitoring tools that let us know when something is not right. I have extensive experience in the AWS cloud and in DevOps best practices, focusing primarily on communication, collaboration, automation and observability pillars",
		keywords: ["freelancer devops engineer", "freelancer cloud engineer", "freelancer operations engineer", "freelancer aws engineer"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["freelancer devops engineer", "freelancer cloud engineer", "freelancer operations engineer", "freelancer aws engineer", "devops guide", "devops tutorial", "cloud guide", "cloud tutorial"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["freelancer devops engineer", "freelancer cloud engineer", "freelancer operations engineer", "freelancer aws engineer"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["freelancer devops engineer", "freelancer cloud engineer", "freelancer operations engineer", "freelancer aws engineer"],
	},
];

export default SEO;
